import React from 'react'
import { DropdownKeys } from '@/modules/results/components/Filters'
import { Autocomplete } from '@wiggot/search-components'
import { ESearchLevel } from '@monopolio-ui/types-library/enums/searchEnums'
import { Skeleton } from '@wiggui/ds/Skeleton'
import { GoogleIcon } from '@wiggui/ds/GoogleIcon'
import { ILocation } from '@monopolio-ui/state-library/stores/filterStore/types'

interface IProps {
  isLoading?: boolean
  isOpen: boolean
  autocompleteValue: string
  locations: ILocation[]
  onDeleteLocation: (id:string) => void
  setIsOpen: ({
    isOpen,
    dropdownKey
  }: {
    isOpen: boolean
    dropdownKey: DropdownKeys
  }) => void
  onChangeLocation?: ({
    id,
    latitude,
    longitude,
    searchLevel,
    searchAddress,
  }: {
    id:string
    latitude: number
    longitude: number
    searchLevel: ESearchLevel
    searchAddress: string
  }) => void
}
export const SearchButton = ({
  setIsOpen,
  onChangeLocation,
  onDeleteLocation,
  isOpen,
  autocompleteValue,
  isLoading,
  locations
}: IProps) => {
  const onSetIsOpen = (isOpen: boolean) => {
    setIsOpen({ isOpen, dropdownKey: 'isOpenSearch' })
  }

  const onFocus = () => {
    onSetIsOpen(true)
  }
  const onBlur = () => {
    onSetIsOpen(false)
  }
  return (
    <div onFocusCapture={onFocus} onBlurCapture={onBlur}>
      {isLoading ? (
        <div
          style={{ height: '100%' }}
          className="flex gap-[10px] items-center px-2"
        >
          <GoogleIcon
            className="text-lg text-primary font-semibold"
            name="search"
          />
          <div className="flex flex-col">
            <p className="text-secondary text-xs font-medium text[12px]">
              Dirección o lugar
            </p>
            <Skeleton width="w-[200px]" height="h-5" />
          </div>
        </div>
      ) : (
        <Autocomplete
          locations={locations}
          onSetValues={onChangeLocation}
          onDeleteLocation={onDeleteLocation}
          enableAutoFetch={false}
          placeholder="Dirección o lugar"
          defaultFieldValue={autocompleteValue}
          resultContainerClassName="md:!w-[400px] !z-[20]"
          fieldContainerClassName="flex-1 max-w-full min-w-[200px] w-full"
          fieldClassName={`!border-none ${
            isOpen
              ? '[&>svg:nth-of-type(2)]:opacity-1'
              : '[&>svg:nth-of-type(2)]:opacity-0'
          } [&>div]:!items-end [&>div]:!gap-1`}
          containerClassName={`flex flex-col justify-center gap-1 w-full rounded-full  active:bg-white active:shadow-[0px_3px_6px_0px_rgba(34,34,34,0.16)] ${
            isOpen
              ? 'bg-white shadow-[0px_3px_6px_0px_rgba(34,34,34,0.16)]'
              : 'hover:bg-surface-strokes'
          }`}
        />
      )}
    </div>
  )
}
